import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  signal,
  SimpleChanges,
  ViewChild,
  WritableSignal
} from '@angular/core';
import { SohoSearchFieldComponent } from 'ids-enterprise-ng';

@Component({
  selector:    'lm-facade-modules',
  standalone: false,
  templateUrl: './lm-facade-modules.component.html',
  styleUrl: './lm-facade-modules.component.scss',
})
export class LMFacadeModulesComponent {

  @Input() moduleFacades: Array<LMModuleFacade> | undefined;
  @Input() state!: LMFacadeExplorerState;

  @Output() moduleSelected: EventEmitter<LMModuleFacadeSelectedEvent> = new EventEmitter<LMModuleFacadeSelectedEvent>();
  @Output() startedSelected: EventEmitter<LMFacadeEvent> = new EventEmitter<LMFacadeEvent>();

  constructor( ) {
    // no-op
  }

  moduleClicked(moduleFacade: LMModuleFacade): void {
    this.state.selectedCategory = moduleFacade.module;
    this.moduleSelected.emit({ type: "onCategorySelected", moduleFacade : moduleFacade });
  }

  startedClicked(): void {
    this.state.selectedCategory = '_start_';
    this.startedSelected.emit({ type: "onGetStartedSelected", });
  }
}
